import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'replace',
})
export class ReplacePipe implements PipeTransform {
    transform(input: string, from: string, to: string): string {
        if (!input || !input.length) { return input; }
        return input.replace(from, to);
    }
}
